<script setup lang="ts">
import { searchCandidatesForSegment } from '@swipe4work/api-orval'
import type { SearchCandidatesForSegmentCandidateItemDto } from '@swipe4work/models-orval'
import type { AutoCompleteCompleteEvent } from 'primevue/autocomplete'

definePage({
  path: '/tools/SkillSuggestion',
  name: '/tools/SkillSuggestion',
  meta: {
    title: 'Skill suggesties testen',
    permission: {
      resource: 'Skills',
      level: 'Read',
    },
  },
})

const selectedCandidate = ref<SearchCandidatesForSegmentCandidateItemDto | null>(null)
const candidateSuggestions = ref<SearchCandidatesForSegmentCandidateItemDto[]>([])

async function onCandidateSearch(event: AutoCompleteCompleteEvent) {
  const result = await searchCandidatesForSegment({ search: event.query })

  candidateSuggestions.value = result?.candidates ?? []
}

function onCandidateClear() {
  selectedCandidate.value = null
}

const candidateUserId = computed(() => selectedCandidate.value?.id ?? null)
</script>

<template>
  <div>
    <Card class="mt-4">
      <template #content>
        <div class="flex flex-col gap-2">
          <label for="candidate">Kandidaat (optioneel)</label>
          <AutoComplete
            input-id="candidate"
            v-model="selectedCandidate"
            :suggestions="candidateSuggestions"
            option-label="displayName"
            placeholder="Zoek een kandidaat..."
            class="w-full"
            @complete="onCandidateSearch"
            @clear="onCandidateClear"
          >
            <template #option="{ option }">
              <div class="flex flex-col gap-0.5">
                <span>{{ option.displayName }}</span>
                <span
                  v-if="option.jobFunctions?.length"
                  class="text-xs text-surface-500"
                >
                  {{ option.jobFunctions.join(', ') }}
                </span>
              </div>
            </template>
          </AutoComplete>
        </div>
      </template>
    </Card>

    <SkillSuggestionPanel :user-id="candidateUserId" class="mt-4" />
  </div>
</template>
